// AI Asistan sohbet penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'aichat.window';

export const aiChatWindowGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'AI Asistan nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Sistemin kullanımıyla ilgili soru sorar, sohbet içinde rapor ve grafik hazırlatırsınız; AI Pro paketinde asistan sizin onayınızla işlem de yapabilir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve düğmeler'),
    body: t(`${G}.regions.body`, 'Mesajlar, rapor ve işlem kartları'),
    footer: t(`${G}.regions.footer`, 'Soru kutusu, mod ve model'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu pencere ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Sağ alttaki AI Asistan düğmesiyle açılan küçük sohbet penceresidir. Masaüstünde aynı düğmeyle kapanır; telefonda pencere tam ekran açılır ve başlıktaki X ile kapanır. Sol kenarını sürükleyerek pencereyi genişletebilirsiniz.'),
      tips: [
        t(`${G}.s1.tip1`, '"Paketler" düğmesi AI Standart ve AI Pro paketlerini tanıtır. Satın almak için bizi aramanız gerekir.'),
        t(`${G}.s1.tip2`, 'Şirketinizde AI paketi yoksa yazdığınız soruya paket tanıtım mesajı gelir; "Paketleri Gör" ve "İletişim sayfasına git" düğmeleri çıkar.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s2.title`, '2. Sorunuzu yazın'),
      text: t(`${G}.s2.text`, 'Alttaki kutuya sorunuzu veya istediğiniz raporu yazın (ör. "Şubelere göre bu ayki satışları göster"). Enter gönderir, Shift+Enter yeni satıra geçer. Yanıt hazırlanırken "Durdur" ile yanıtı kesebilirsiniz; mesajınız kutuya geri gelir.'),
      tips: [
        t(`${G}.s2.tip1`, 'Bir mesaj en fazla 2000 karakter olabilir.'),
        t(`${G}.s2.tip2`, 'Aylık kullanım hakkınız dolarsa kutu kilitlenir ve uyarı çıkar; hakkı artırmak için yöneticinizle görüşün.'),
        t(`${G}.s2.tip3`, 'Yoğunluk gibi geçici bir sorunda sarı uyarıdaki "Devam Et" ile yarım kalan görev kaldığı yerden sürer.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s3.title`, '3. Mod ve model seçin'),
      text: t(`${G}.s3.text`, 'Kutunun altındaki ilk açılır menü modu seçer: "Soru" sorularınızı yanıtlar ve rapor hazırlar; "Ajan" sizin adınıza uygulamada işlem yapabilir; "Plan" sizinle konuşarak adım adım bir görev planı kurar. Ajan ve Plan modları AI Pro paketi açık şirketlerde seçilebilir.'),
      tips: [
        t(`${G}.s3.tip1`, 'İkinci menü yapay zekâ modelini seçer. Gemini Pro yalnız AI Pro paketinde açıktır ve yanında "5× token" yazar: kullanım hakkınızdan daha fazla düşer.'),
        t(`${G}.s3.tip2`, 'Seçtiğiniz model bu tarayıcıda hatırlanır. "Çok Yakında" altındaki modeller henüz seçilemez.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Rapor kartını inceleyin, Dashboard\'a ekleyin'),
      text: t(`${G}.s4.text`, 'Rapor istediğinizde yanıtın altında "Rapor önizleme" kartı çıkar. Kartın üstünde raporun tarih aralığı yazar; aralık belirtmediyseniz son 30 gün kullanılır. Büyütme simgesi raporu geniş pencerede açar. "Dashboard\'a ekle" kartı Dashboard sayfanıza ekler.'),
      tips: [
        t(`${G}.s4.tip1`, 'Eklenen rapor kartları bu tarayıcıda saklanır; başka bilgisayar veya tarayıcıda görünmez.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Ajan işlemlerini onaylayın'),
      text: t(`${G}.s5.text`, 'Ajan modunda asistanın yapacağı her işlem bir kartta görünür. Yalnız bilgi okuyan işlemler kendiliğinden çalışır. Veri değiştirecek işlemlerde "Bu işlem veri değiştirecek. Onaylıyor musunuz?" sorusu çıkar: "Onayla" çalıştırır, "Vazgeç" iptal eder.'),
      tips: [
        t(`${G}.s5.tip1`, '"Tümünü Onayla": bu görev bitene kadar sonraki işlemler de onay beklemeden çalışır. Yeni mesaj yazdığınızda veya bir işlemi reddettiğinizde bu durum biter.'),
        t(`${G}.s5.tip2`, 'Kartın sağında sonuç yazar: Çalıştırıldı, İptal edildi veya Başarısız.'),
      ],
    },
    {
      region: 'header',
      title: t(`${G}.s6.title`, '6. Yeni konuşma, geçmiş ve planlar'),
      text: t(`${G}.s6.text`, 'Başlıktaki "Yeni konuşma" boş bir sohbet açar. "Konuşma geçmişi" önceki konuşmalarınızı listeler; birine tıklayınca kaldığınız yerden devam edersiniz, "Sohbete dön" ile geri gelirsiniz. Bu düğmeler AI paketi açık şirketlerde görünür.'),
      tips: [
        t(`${G}.s6.tip1`, '"Plan Modu" düğmesi (Plan modu açık şirketlerde) pencerenin solunda planlar panelini açar: görevleri tek tek "Şimdi yap" ile veya sırayla "Tümünü yap" ile asistana yaptırırsınız.'),
        t(`${G}.s6.tip2`, '"Tümünü yap" kalan görevleri sırayla çalıştırır ve işlem onaylarını otomatik verir; asistan bir soru sorarsa akış durur.'),
      ],
    },
  ],
});
